import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import TabPanel from 'components/TabPanel';
import TabContent from './TabContent';
import { StyledWatchlistPage } from './StyledComponents';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';

const WatchlistPage = (props) => {
  const { items, fetchWatchlist, loadExtraWatchlistItems, removeItem } = props;

  const onTabEnter = useCallback(
    ({ id }) => {
      const dashboardName = id === 'vod' ? 'MY_WATCHLIST' : 'CHANNELS_FAVORITES';

      innerAnalyticsVolia.postEvent({
        eventGroup: `dashboard: ${dashboardName}`,
        eventName: 'open dashboard',
      });

      fetchWatchlist(id);
    },
    [fetchWatchlist],
  );

  return (
    <StyledWatchlistPage>
      <TabPanel title={i18n.t('watchlist.title')} onEnter={onTabEnter}>
        <TabPanel.Tab id="catchup" title={i18n.t('watchlist.catchup.title')} path="catchup">
          <TabContent
            content={items.catchup}
            loadExtraItems={loadExtraWatchlistItems}
            removeItem={removeItem}
            emptyPlaceholder={i18n.t('watchlist.catchup.emptyPlaceholder')}
            type="catchup"
          />
        </TabPanel.Tab>
        <TabPanel.Tab id="vod" title={i18n.t('watchlist.vod.title')} path="vod">
          <TabContent
            content={items.vod}
            loadExtraItems={loadExtraWatchlistItems}
            removeItem={removeItem}
            emptyPlaceholder={i18n.t('watchlist.vod.emptyPlaceholder')}
            type="vod"
          />
        </TabPanel.Tab>
        <TabPanel.Tab id="channel" title={i18n.t('watchlist.channel.title')} path="channel">
          <TabContent
            content={items.channel}
            loadExtraItems={loadExtraWatchlistItems}
            removeItem={removeItem}
            emptyPlaceholder={i18n.t('watchlist.channel.emptyPlaceholder')}
            type="channel"
          />
        </TabPanel.Tab>
      </TabPanel>
    </StyledWatchlistPage>
  );
};

WatchlistPage.defaultProps = {
  items: {},
};

WatchlistPage.propTypes = {
  items: PropTypes.shape({
    catchup: PropTypes.object.isRequired,
    channel: PropTypes.object.isRequired,
    vod: PropTypes.object.isRequired,
  }).isRequired,
  fetchWatchlist: PropTypes.func.isRequired,
  loadExtraWatchlistItems: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
};

export default WatchlistPage;
